<template>
  <div class="p-4 border rounded-md" :class="classes.background">
    <div class="flex">
      <div class="flex-shrink-0 mr-3" v-if="icon" :class="classes.icon">
        <fa :icon="['fas', icon]" fixed-width />
      </div>
      <div>
        <h5 class="mb-2 text-sm font-medium" v-if="!!$slots.title" :class="classes.title">
          <slot name="title" />
        </h5>
        <div class="text-sm" :class="classes.text">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'Alert',
  
  props: {
    icon: {
      type: String
    },

    type: {
      type: String,
      default: 'default'
    }
  },

  computed: {
    classes () {
      const map = {
        default: {
          background: 'bg-gray-50 border-gray-300',
          title: 'text-gray-800',
          text: 'text-gray-600',
          icon: 'text-gray-400'
        }, 
        info: {
          background: 'bg-indigo-50 border-indigo-300',
          title: 'text-indigo-800',
          text: 'text-indigo-700',
          icon: 'text-indigo-500'
        },
        success: {
          background: 'bg-green-50 border-green-300',
          title: 'text-green-800',
          text: 'text-green-700',
          icon: 'text-green-500'
        },
        warning: {
          background: 'bg-amber-50 border-amber-300',
          title: 'text-amber-800',
          text: 'text-amber-700',
          icon: 'text-amber-500'
        },
        error: {
          background: 'bg-red-50 border-red-300',
          title: 'text-red-800',
          text: 'text-red-700',
          icon: 'text-red-500'
        }
      }

      return map[this.type]
    }
  }
}
</script>